import { render, staticRenderFns } from "./ShippingAddFormConfig.vue?vue&type=template&id=a27b8366"
import script from "./ShippingAddFormConfig.vue?vue&type=script&lang=js"
export * from "./ShippingAddFormConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports